import Vue from 'vue'
import Vuex from 'vuex'
//modules
import dbRefs from './modules/dbRefs'
import gen from './modules/gen'
//auth
import auth from './modules/auth/auth'
import emailPassword_signup from './modules/auth/emailPassword_signup'
import emailPassword_login from './modules/auth/emailPassword_login'
import emailMagic_login from './modules/auth/emailMagic_login'
import emailPassword_otherFunctions from './modules/auth/emailPassword_otherFunctions'
import socialMedia from './modules/auth/socialMedia'
//user
import userDetails from './modules/user/userDetails'
import uploadProfilePhoto from './modules/user/uploadProfilePhoto'
//uploadImage
import uploadImage_1 from './modules/uploadImage/uploadImage_1'
import uploadImage_2 from './modules/uploadImage/uploadImage_2'
import uploadImage_3 from './modules/uploadImage/uploadImage_3'
import uploadImage_4 from './modules/uploadImage/uploadImage_4'
import uploadImage_5 from './modules/uploadImage/uploadImage_5'
//
import hello from './modules/hello'
//image recognition apis
import googleCloudVisionAPI from './modules/uploadImage/googleCloudVisionAPI'
import imaggaAPI from './modules/uploadImage/imaggaAPI'
// common
import common from './modules/common/common'
// custom list
import customList from './modules/customList/customList'
//imageDetails
import imageDetails from './modules/imageDetails/imageDetails'
//userProfileDetails
import userProfile from './modules/user/userProfile'
// filter
import filter from './modules/filter/filter'
//
import search_loc from './modules/filter/search_loc'
//
import search from './modules/search/search'
Vue.use(Vuex)

export const store = new Vuex.Store({
  modules:{
    //
    dbRefs,
    gen,
    //
    auth,
    emailPassword_signup,
    emailPassword_login,
    emailMagic_login,
    emailPassword_otherFunctions,
    socialMedia,
    //
    userDetails,
    //
    uploadProfilePhoto,
    //
    uploadImage_1,
    uploadImage_2,
    uploadImage_3,
    uploadImage_4,
    uploadImage_5,
    //
    hello,
    //
    googleCloudVisionAPI,
    imaggaAPI,
    //
    common,
    //
    customList,
    //
    imageDetails,
    //
    userProfile,
    //
    filter,
    search_loc,
    search
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js